import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
  ["Usługi", "#uslugi"],
  ["Dlaczego my", "#dlaczego"],
  ["Kontakt", "#kontakt"],
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-white/5 bg-ink/75 backdrop-blur-xl">
      <nav className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-6 md:px-10">
        <a href="#top" data-testid="nav-logo" aria-label="Bass Lab – start">
          <Logo size={36} />
        </a>

        <ul className="hidden md:flex items-center gap-9">
          {LINKS.map(([label, href]) => (
            <li key={href}>
              <a
                data-testid={`nav-link-${href.slice(1)}`}
                href={href}
                className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-brand"
              >
                {label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#kontakt"
          data-testid="nav-cta"
          className="hidden md:inline-flex items-center rounded-full bg-brand px-6 py-3 text-xs font-bold uppercase tracking-[0.15em] text-ink transition-all duration-300 hover:bg-brand-dark hover:-translate-y-0.5"
        >
          Darmowa wycena
        </a>

        <button
          data-testid="nav-burger"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Zamknij menu" : "Otwórz menu"}
          className="md:hidden grid place-items-center h-11 w-11 rounded-full border border-white/10 text-white"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden absolute inset-x-0 top-full border-b border-white/5 bg-ink/95 backdrop-blur-xl"
            data-testid="nav-mobile-menu"
          >
            <ul className="flex flex-col px-6 py-6 gap-1">
              {LINKS.map(([label, href], i) => (
                <li key={href}>
                  <a
                    href={href}
                    onClick={() => setOpen(false)}
                    className="block py-3 font-display text-3xl font-semibold uppercase tracking-tight text-zinc-200 hover:text-brand transition-colors"
                  >
                    <span className="text-sm text-brand mr-3">0{i + 1}</span>
                    {label}
                  </a>
                </li>
              ))}
              <li className="mt-4">
                <a
                  href="#kontakt"
                  onClick={() => setOpen(false)}
                  data-testid="nav-mobile-cta"
                  className="inline-flex rounded-full bg-brand px-7 py-3.5 text-xs font-bold uppercase tracking-[0.15em] text-ink"
                >
                  Darmowa wycena
                </a>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
